import React from "react";
import { addIntercomMsg, isFbHashtagFilter, isOnboardingPremiumNetwork } from "../../../../../../../utils";

const AddContentTranscript = ({ selectedNetworkId, filterTabs, selectedFilterId, postCount, feedName, stepCompleted }) => {
    if ((!selectedNetworkId || isOnboardingPremiumNetwork(selectedNetworkId)) && !stepCompleted) return null;
    const selectedFilter = filterTabs?.find(item => item.filter == selectedFilterId);
    const filterTypeLabel = selectedFilter?.feedName ? selectedFilter.feedName.toLowerCase() : 'hashtag';
    const isFbHashtag = isFbHashtagFilter(selectedNetworkId, selectedFilterId);

    const rawTag = (feedName || 'puma').replace(/^#/, '');
    const lowercaseTag = rawTag.toLowerCase();
    const capitalizedTag = rawTag.charAt(0).toUpperCase() + rawTag.slice(1);

    return (
        <div className="mb-3 clearfix ob-step-block-2">
            <div className="ob-step-pill">Step 2</div>
            <div className="selectSource-chatbox mt-2">
                <div className="selectSource-list ob-user-bubble">
                    <p>Next, collect your content using the options on the right.</p>
                </div>

                {isFbHashtag ? (
                    <div className="selectSource-list">
                        <p className="fb-hashtag-premium-msg">Great choice! 🎯 Facebook Hashtag (#) is a <strong>Premium feed source</strong> available exclusively on our <strong>Enterprise plan</strong>. <span className="cursor-pointer text-decoration-underline" onClick={() => addIntercomMsg(`Hi! 👋\nI'd like to collect content from a Facebook Hashtag on my Social Wall.`)}>Chat with Us</span> to upgrade.</p>
                    </div>
                ) : (selectedFilterId || stepCompleted >= 2 || feedName || postCount) ? (
                    <div className="selectSource-list">
                        <p>Great choice! 🎯 Now enter the {filterTypeLabel} you’d like to collect content from.</p>
                    </div>
                ) : null}

                {(feedName || stepCompleted >= 2 || postCount) ? (
                    <div className="selectSource-list ob-user-bubble">
                        <p>You’ve entered the <strong>#{lowercaseTag}</strong> Hashtag.</p>
                    </div>
                ) : null}

                {(postCount || stepCompleted >= 2 || feedName) ? (
                    <div className="selectSource-list">
                        <p>“Great! 🎉 We found content from #{capitalizedTag}. Take a look at the posts on the right.”</p>
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default AddContentTranscript;
